import { useQuery } from "@tanstack/react-query";
import { SubcategoryModel } from "api/client.generated";
import useApi from "./useApi";

interface UseConnectWiseProductSubcategoriesReturn {
  cwProductSubcategories: SubcategoryModel[] | undefined;
  isCwProductSubcategoriesFetching: boolean;
}

const useConnectWiseProductSubcategories = (): UseConnectWiseProductSubcategoriesReturn => {
  const { connectWiseApiProxyClient } = useApi();

  const loadData = async (): Promise<SubcategoryModel[]> => {
    const response = await connectWiseApiProxyClient.getCatalogItemSubcategories();
    return response.items;
  };

  const { data, isFetching } = useQuery({
    queryKey: ["getCatalogItemSubcategories"],
    queryFn: loadData,
  });

  return {
    cwProductSubcategories: data,
    isCwProductSubcategoriesFetching: isFetching,
  };
};

export default useConnectWiseProductSubcategories;
